export const ONBOARDING_STEPS = [
	{ key: "import", labelKey: "step_import", path: "/catalog/products" },
	{ key: "catalog", labelKey: "step_catalog", path: "/catalog/products" },
	{ key: "order", labelKey: "step_order", path: "/work-items" },
	{ key: "export", labelKey: "step_export", path: "/orders" },
	{ key: "team", labelKey: "step_team", path: "/settings/members" },
] as const;

export type StepKey = (typeof ONBOARDING_STEPS)[number]["key"];

export interface OnboardingState {
	step: number;
	mode?: "stepper" | "chat";
	/** Conversation ID for chat-based onboarding */
	chatThreadId?: string;
	feedImported: boolean;
	catalogExplored: boolean;
	orderProcessed: boolean;
	exportDone: boolean;
	teamInvited: boolean;
	completedAt?: string;
	dismissed?: boolean;
}

export const INITIAL_STATE: OnboardingState = {
	step: 0,
	feedImported: false,
	catalogExplored: false,
	orderProcessed: false,
	exportDone: false,
	teamInvited: false,
};

import i18n from "i18next";

export function getDemoOrderText(): string {
	return i18n.t("onboarding:demo_order_text");
}
